module.exports = __webpack_public_path__ + "img/Frame-40.4cabfa6c.svg";